<template>
  <div>
    <vx-card>
      <div class="flex pb-5">
        <div class="flex-1">
          {{ $t("sections.accounting.dataForm.itemCounts", {max: contracts.length}) }}
        </div>
      </div>
      <vs-table :data="contracts">
        <template slot="thead">
          <vs-th>ลำดับ</vs-th>
          <vs-th>เลขที่สัญญา</vs-th>
          <vs-th>ชื่อสัญญา</vs-th>
          <vs-th>หลักสูตร</vs-th>
          <vs-th>วันที่ปรับโครงสร้างหนี้</vs-th>
          <vs-th>ประเภทปรับโครงสร้างหนี้</vs-th>
          <vs-th>วันที่ค้างชำระ / จำนวนวัน</vs-th>
          <vs-th>ยอดส่งฟ้อง</vs-th>
        </template>
        <template slot-scope="{ data }">
          <vs-tr :key="index" v-for="(row, index) in data">
            <vs-td>
              {{ index + 1 }}
            </vs-td>
            <vs-td>
              <router-link :to="{ name: 'accounting-contract-detail', params: {id: row.id}}">{{
                  row.contractNo
                }}
              </router-link>
            </vs-td>
            <vs-td>
              {{ row.contractName }}{{ row.restructuring ? '*' : '' }}
            </vs-td>
            <vs-td>
              {{ row.curriculum.nameTh }}
            </vs-td>
            <vs-td>
              {{ row.restructuringDetail.restructuringDate  | convYYYYMMDDToDDMMYYYYBE }}
            </vs-td>
            <vs-td>
              {{ row.restructuringTypeName }}
            </vs-td>
            <vs-td>
              {{ row.loan.agingDate | convYYYYMMDDToDDMMYYYYBE }} ({{ row.loan.agingNumber }})
            </vs-td>
            <vs-td>
              {{ summaryTotalAmount(row) | numberFormat }}
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
  </div>
</template>

<script>
import {createNamespacedHelpers} from 'vuex'
import {round} from "@/utils";

const {mapActions: mapNotificationActions, mapState: mapNotificationFields} = createNamespacedHelpers('Notification')

export default {
  name: 'IsRestructuringAgingMoreThan90Days',
  data() {
    return {
      loading: false
    }
  },
  async created() {
    const vm = this
    await vm.getNotificationContractsIsRestructuringAgingMoreThan90Days({
      action: vm.$route.params.action,
    })
  },
  computed: {
    ...mapNotificationFields(['status', 'notificationContracts']),
    contracts() {
      if (!this.notificationContracts) return [];

      return [...this.notificationContracts].sort((a, b) => {
        const agingA = a.loan && typeof a.loan.agingNumber === 'number' ? a.loan.agingNumber : 0;
        const agingB = b.loan && typeof b.loan.agingNumber === 'number' ? b.loan.agingNumber : 0;
        return agingB - agingA;
      });
    }

  },
  methods: {
    ...mapNotificationActions(['getNotificationContractsIsRestructuringAgingMoreThan90Days']),
    dateOfCourtJudgment(row) {
      return row.prosecution.dateOfCourtJudgment
    },
    prosecutionResultName(row) {
      return row.prosecution.prosecutionResultName
    },
    caseStatusName(row) {
      if (row.prosecution === null) return ''
      return row.prosecution.caseStatusName
    },
    summaryTotalAmount({loan}) {
      const {
        restructuringFeeRemain,
        restructuringPenaltyRemain,
        restructuringInterestRemain,
        restructuringPrincipleRemain,
        accruedFeeRemain,
        accruedPenaltyRemain,
        accruedInterestRemain,
        principleRemain
      } = loan;
      return round(restructuringFeeRemain + restructuringPenaltyRemain + restructuringInterestRemain + restructuringPrincipleRemain + accruedFeeRemain + accruedPenaltyRemain + accruedInterestRemain + principleRemain, 2);
    }
  },
  watch: {
    status: {
      handler(res) {
        if (res.processing !== null) {
          if (res.processing) {
            this.$vs.loading();
          } else {
            this.$vs.loading.close();
          }
        }
        if (res.success !== null) {
          this.$vs.notify({...res.success})
        } else if (res.error !== null) {
          this.$vs.notify({...res.error})
        }
      },
      deep: true
    },
  }
}
</script>
